import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { SelectionModel } from "@angular/cdk/collections";
import { FlatTreeControl } from "@angular/cdk/tree";
import {
  MatTreeFlatDataSource,
  MatTreeFlattener,
  MatTreeModule,
} from "@angular/material/tree";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSelectModule } from "@angular/material/select";
import { MatButtonModule } from "@angular/material/button";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import swal from "sweetalert2";
import { PerfilService } from "../perfil.service";
import { Menu } from "src/app/shared/model/security/menu.model";
import { Perfil } from "src/app/shared/model/security/perfil.model";
import { arbolDelEditor } from "../arbol-del-editor";

export class TodoItemFlatNode {
  id!: number;
  id_Padre!: number;
  item!: string;
  level!: number;
  expandable!: boolean;
}

@Component({
  selector: "app-perfilalta",
  standalone: true,
  templateUrl: "./perfilalta.component.html",
  imports: [
    FormsModule,
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatIconModule,
    MatCheckboxModule,
    MatTreeModule,
  ],
})
export class PerfilAltaComponent implements OnInit {
  flatNodeMap = new Map<TodoItemFlatNode, Menu>();
  nestedNodeMap = new Map<Menu, TodoItemFlatNode>();
  selectedParent: TodoItemFlatNode | null = null;
  getLevel = (node: TodoItemFlatNode) => node.level;
  isExpandable = (node: TodoItemFlatNode) => node.expandable;
  getChildren = (node: Menu): Menu[] => node.hijos ?? [];
  hasChild = (_: number, nodeData: TodoItemFlatNode) => nodeData.expandable;
  transformer = (node: Menu, level: number) => {
    const existingNode = this.nestedNodeMap.get(node);
    const flatNode =
      existingNode && existingNode.item === node.nombre
        ? existingNode
        : new TodoItemFlatNode();
    flatNode.item = node.nombre;
    flatNode.id = node.id;
    flatNode.id_Padre = node.id_Padre;
    flatNode.level = level;
    flatNode.expandable = !!node.hijos?.length;
    this.flatNodeMap.set(flatNode, node);
    this.nestedNodeMap.set(node, flatNode);
    return flatNode;
  };

  checklistSelection = new SelectionModel<TodoItemFlatNode>(true);
  treeControl = new FlatTreeControl<TodoItemFlatNode>(
    this.getLevel,
    this.isExpandable
  );
  treeFlattener = new MatTreeFlattener(
    this.transformer,
    this.getLevel,
    this.isExpandable,
    this.getChildren
  );
  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

  sitioperfil: any[] = [];
  listaModulo: Menu[] = [];
  selectedValue = "";
  verSeleccion = "";
  milista: Menu[] = [];
  beanPerfil = new Perfil();
  nombre = "";
  loadingMenus = false;

  constructor(private router: Router, private perfil: PerfilService) {}

  ngOnInit() {
    this.ngConsultaSitios();
  }

  get selectedMenusCount(): number {
    return this.checklistSelection.selected.length;
  }

  descendantsAllSelected(node: TodoItemFlatNode): boolean {
    const descendants = this.treeControl.getDescendants(node);
    return descendants.every((child) => this.checklistSelection.isSelected(child));
  }

  descendantsPartiallySelected(node: TodoItemFlatNode): boolean {
    const descendants = this.treeControl.getDescendants(node);
    const result = descendants.some((child) =>
      this.checklistSelection.isSelected(child)
    );
    return result && !this.descendantsAllSelected(node);
  }

  todoItemSelectionToggle(node: TodoItemFlatNode): void {
    this.checklistSelection.toggle(node);
    const descendants = this.treeControl.getDescendants(node);
    this.checklistSelection.isSelected(node)
      ? this.checklistSelection.select(...descendants)
      : this.checklistSelection.deselect(...descendants);
    this.checkAllParentsSelection(node);
  }

  todoLeafItemSelectionToggle(node: TodoItemFlatNode): void {
    this.checklistSelection.toggle(node);
    this.checkAllParentsSelection(node);
  }

  checkAllParentsSelection(node: TodoItemFlatNode): void {
    let parent: TodoItemFlatNode | null = this.getParentNode(node);
    while (parent) {
      this.checkRootNodeSelection(parent);
      parent = this.getParentNode(parent);
    }
  }

  checkRootNodeSelection(node: TodoItemFlatNode): void {
    const nodeSelected = this.checklistSelection.isSelected(node);
    const descendants = this.treeControl.getDescendants(node);
    const descendantsAllSelected = descendants.every((child) =>
      this.checklistSelection.isSelected(child)
    );
    if (nodeSelected && !descendantsAllSelected) {
      this.checklistSelection.deselect(node);
    } else if (!nodeSelected && descendantsAllSelected) {
      this.checklistSelection.select(node);
    }
  }

  getParentNode(node: TodoItemFlatNode): TodoItemFlatNode | null {
    const currentLevel = this.getLevel(node);
    if (currentLevel < 1) {
      return null;
    }
    const startIndex = this.treeControl.dataNodes.indexOf(node) - 1;
    for (let index = startIndex; index >= 0; index--) {
      const currentNode = this.treeControl.dataNodes[index];
      if (this.getLevel(currentNode) < currentLevel) {
        return currentNode;
      }
    }
    return null;
  }

  ngConsultaSitios() {
    this.perfil.ConsultaSitios().subscribe((res) => {
      this.sitioperfil = Array.isArray(res) ? res : [];
    });
  }

  capturar(nombre: string) {
    this.verSeleccion = this.selectedValue;
    this.milista = [];
    this.checklistSelection.clear();
    this.ngConsultaMenus(nombre);
  }

  ngConsultaMenus(nombre: string) {
    if (!nombre) {
      this.listaModulo = [];
      this.dataSource.data = [];
      return;
    }

    this.loadingMenus = true;
    // El arbol del sitio elegido y el de Base: el servidor acepta y
    // reemplaza exactamente esos dos (ver arbol-del-editor.ts).
    arbolDelEditor(this.perfil, nombre).subscribe({
      next: (res) => {
        this.listaModulo = Array.isArray(res) ? res : [];
        this.dataSource.data = this.listaModulo;
        this.treeControl.collapseAll();
        this.loadingMenus = false;
      },
      error: () => {
        this.listaModulo = [];
        this.dataSource.data = [];
        this.loadingMenus = false;
      },
    });
  }

  Guardar() {
    this.beanPerfil.nombre = this.nombre?.trim();
    this.beanPerfil.sitio = this.selectedValue;
    this.milista = this.checklistSelection.selected.map((node) => ({
      factory: "",
      id: node.id,
      id_Padre: node.id_Padre,
      icono: "",
      nombre: node.item,
      tipo: "",
    }));
    this.beanPerfil.menus = this.milista;

    if (!this.beanPerfil.nombre || !this.beanPerfil.sitio) {
      swal.fire({
        title: "Ops!",
        text: "Faltan campos por llenar",
        icon: "error",
        confirmButtonColor: "danger",
        showConfirmButton: true,
      });
      return;
    }

    this.perfil.GuardaPerfil(this.beanPerfil).subscribe({
      next: () => {
        this.perfil.setPerfilesCache(null);
        swal
          .fire({
            title: "Se insertó correctamente",
            timer: 5000,
            icon: "success",
            showConfirmButton: true,
          })
          .then(() => this.back());
      },
      error: (e) => {
        swal.fire({
          title: "No fue posible guardar el perfil",
          text: e instanceof Error && e.message ? e.message : "Intenta nuevamente en unos momentos.",
          icon: "error",
          showConfirmButton: true,
        });
      },
    });
  }

  back(): void {
    this.router.navigate(["/admin/perfil"]);
  }
}
